import React, { useMemo } from 'react';
import Icon from 'components/Icon';

const LoadingSpinner = ({ loading }) => {
    const spinDirection = useMemo(() => {
        return Math.random() < 0.5 ? 'rotate-clockwise' : 'rotate-counterclockwise';
    }, []); // only pick once when mounted

    const spinnerClass = loading ? spinDirection : `no-spin ${spinDirection}`;

  return <Icon category="ui" name='tripPlanner' className={`trip-icon ${spinnerClass}`} />;
};

export default LoadingSpinner;
